import { useRouter } from 'next/router';

type PageTransitionProps = {
  children: React.ReactNode;
};

// Visual fade wrapper for page navigations.
//
// `key={router.pathname}` causes React to remount the wrapper subtree
// whenever the underlying page route changes, and CSS `animate-fadeIn`
// plays once on each mount. Query-only updates (e.g. dashboard tabs via
// ?tabId=...) don't change pathname, so they don't replay the fade.
//
// NOTE: this component cannot fix "URL updated but page didn't" symptoms
// caused by Next.js's static export client routing dropping React context
// updates — because the children prop comes from `_app.tsx`, which decides
// what to render based on its own `useRouter()` call. If that's stale, the
// children are stale regardless of what we do here. That class of bug has
// to be fixed in `_app.tsx`.
export default function PageTransition({ children }: PageTransitionProps) {
  const router = useRouter();

  return (
    <div
      key={router.pathname}
      className="animate-fadeIn"
      style={{ minHeight: '100vh' }}
    >
      {children}
    </div>
  );
}
